import { useLoaderData, useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Icon, Type } from '@mindstep-axa-dmhi/dmhi-frontend-components';
import {
  Button,
  ButtonGroup,
  Link,
  Progress,
} from '../../../../components';
import useCanonical from '../../../../hooks/use-canonical';
import { LayoutScreeningSection } from '../../../../layouts';
import useScreening from '../../hooks/use-screening';

function Section() {
  const { Screening } = useLoaderData();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sectionIndex } = useParams();
  const { canonical } = useCanonical();
  const { sections, section } = useScreening({
    Screening,
    sectionIndex,
    questionIndex: 0,
  });
  const total = sections.length;
  const current = parseInt(sectionIndex, 10);
  const progressLabel = t('section_card.progress', { current, total });
  const hero = (
    <div
      className="bg-cover bg-no-repeat h-[250px] w-full bg-center lg:h-auto"
      style={{ backgroundImage: `url(${section.background})` }}
    />
  );

  return (
    <LayoutScreeningSection hero={hero}>
      <link rel="canonical" href={canonical} />
      <div className="flex w-full max-w-[690px] flex-col gap-8 md:gap-12 mx-auto">
        <div className="w-full lg:px-5 lg:py-6 lg:shadow-xs lg:rounded-sm lg:bg-white">
          <Progress total={total} current={current - 1} label={progressLabel} />
        </div>
        <div>
          <Type variant="h1" className="text-center lg:text-3xl">{t(section.title)}</Type>
          <p className="mt-7 text-left lg:text-xl">{t(section.content)}</p>
        </div>
        <ButtonGroup row>
          <Button
            variant="default"
            type="button"
            onClick={(e) => { e.preventDefault(); navigate(-1); }}
            size="sm"
            className="flex items-center gap-4 text-axa-blue-400"
            tabIndex="-1"
            id="back"
          >
            <Icon variant="navigate-before" className="inline fill-axa-blue-400" />
            {t('back')}
          </Button>
          <Button
            component={Link}
            to="q/1"
            variant="primary"
            id="continue"
          >
            {t('continue')}
          </Button>
        </ButtonGroup>
      </div>
    </LayoutScreeningSection>
  );
}

export default Section;
